// English language pack
export const en = {
  language: "en",
  // Navigation
  nav: {
    home: "Home",
    chat: "AI Chat Practice",
    textAnalysis: "Text Analysis",
    imageAnalysis: "Image Analysis",
    history: "Learning History"
  },
  
  // Home
  home: {
    title: "Linguamate Pro",
    subtitle: "Intelligent Language Learning Assistant",
    description: "Enhance your language learning experience with AI technology",
    hero: {
      title: "Let AI combine linguistic principles",
      subtitle: "Create personalized language learning experience",
      description: "Linguamate Pro is a multimodal language learning companion that uses artificial intelligence to help learners master language in authentic contexts",
      startTextAnalysis: "Start Text Analysis",
      uploadImage: "Upload Image Analysis"
    },
    features: {
      chat: "AI Chat Practice",
      textAnalysis: "Text Analysis",
      imageAnalysis: "Image Analysis",
      history: "Learning History",
      textAnalysisDesc: "Upload text content for AI-powered linguistic analysis including vocabulary, grammar, and semantics",
      imageAnalysisDesc: "Upload textbook screenshots or images for OCR recognition and linguistic analysis",
      chatDesc: "Practice language skills through real-time conversations with AI in authentic scenarios"
    },
    coreFeatures: "Core Features",
    whyChoose: "Why Choose Linguamate Pro?",
    demo: "Demo Scenarios",
    cta: {
      title: "Start Your Language Learning Journey",
      description: "Experience AI-driven personalized language learning",
      startNow: "Start Now"
    },
    getStarted: "Get Started",
    highlights: {
      linguisticsDriven: "Linguistics-Driven",
      linguisticsDrivenDesc: "Based on morphology, syntax, semantics, pragmatics and other linguistic theories",
      personalizedLearning: "Personalized Learning",
      personalizedLearningDesc: "Generate suitable learning materials and exercises based on learner's level",
      immersiveExperience: "Immersive Experience",
      immersiveExperienceDesc: "Learn in authentic contexts to improve practical language skills"
    },
    demoScenarios: {
      title: "Demo Scenarios",
      uploadTextbook: "Upload Textbook Screenshots",
      uploadTextbookDesc: "AI recognizes and outputs vocabulary lists and grammar analysis",
      chooseLearningMode: "Choose Learning Mode",
      chooseLearningModeDesc: "AI generates summaries and exercises using simplified language",
      chatPractice: "Chat Practice",
      chatPracticeDesc: "Simulate real scenarios with AI as your conversation partner"
    }
  },
  
  // AI Chat Practice
  chat: {
    title: "AI Chat Practice",
    subtitle: "Have natural conversations with AI to improve your language skills",
    placeholder: "Type your message...",
    send: "Send",
    level: "Learning Level",
    context: "Conversation Context",
    contexts: {
      casual: "Casual Chat",
      business: "Business Communication",
      academic: "Academic Discussion",
      travel: "Travel Communication"
    },
    levels: {
      beginner: "Beginner",
      intermediate: "Intermediate",
      advanced: "Advanced"
    },
    learningSettings: "Learning Settings",
    learningContext: "Learning Context (Optional)",
    contextPlaceholder: "e.g., Restaurant ordering, Business meeting, etc.",
    conversationStarters: "Conversation Starters",
    clearChat: "Clear Chat",
    noMessages: "No messages yet, start a conversation!",
    sampleScenarios: "Sample Scenarios"
  },
  
  // Text Analysis
  textAnalysis: {
    title: "Text Analysis",
    subtitle: "Deep text analysis with personalized exercises",
    step1: "Step 1: Input Text",
    step2: "Step 2: Linguistic Analysis",
    step3: "Step 3: Exercises",
    inputPlaceholder: "Please enter English text to analyze...",
    analyze: "Start Analysis",
    generateExercises: "Generate Exercises",
    restart: "Restart",
    level: "Learning Level",
    analysisComplete: "Analysis Complete",
    exercisesComplete: "Exercises Generated",
    submitAnswer: "Submit Answer",
    yourAnswer: "Your Answer",
    correctAnswer: "Correct Answer",
    explanation: "Explanation",
    correct: "Correct!",
    incorrect: "Incorrect",
    originalText: "Original Text",
    originalTextTitle: "Your Input Text",
    originalTextDescription: "Below is the text you entered, which was used to generate the linguistic analysis and exercises"
  },
  
  // Image Analysis
  imageAnalysis: {
    title: "Image Analysis",
    subtitle: "Upload images for OCR and language analysis",
    upload: "Upload Image",
    analyze: "Analyze Image",
    result: "Analysis Result",
    step1: "Step 1: Upload Image",
    step2: "Step 2: Image Recognition",
    step3: "Step 3: Language Analysis",
    step4: "Step 4: Exercises",
    uploadPlaceholder: "Click or drag image here",
    supportedFormats: "Supports JPG, PNG, GIF formats",
    analysisComplete: "Analysis Complete",
    ocrComplete: "OCR Recognition Complete",
    noImage: "Please upload an image first",
    processing: "Processing...",
    restart: "Restart",
    extractedText: "Extracted Text Content",
    analysisResult: "Linguistic Analysis Result",
    generateExercises: "Generate Exercises",
    personalizedExercises: "Personalized Exercises",
    exercisesComplete: "Exercises Generated",
    startAnalysis: "Start Analysis"
  },
  
  // Learning History
  history: {
    title: "Learning History",
    subtitle: "View your learning records and progress",
    noHistory: "No learning records yet",
    date: "Date",
    type: "Type",
    content: "Content",
    score: "Score",
    textAnalysis: "Text Analysis",
    imageAnalysis: "Image Analysis",
    chatPractice: "Chat Practice",
    loading: "Loading...",
    error: "Failed to load, please retry"
  },
  
  // Common
  common: {
    loading: "Loading...",
    error: "Error",
    retry: "Retry",
    success: "Success",
    cancel: "Cancel",
    confirm: "Confirm",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    close: "Close"
  }
};
